import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=1902bcf4&scoped=true&"
import script from "./companyList.vue?vue&type=script&lang=js&"
export * from "./companyList.vue?vue&type=script&lang=js&"
import style0 from "./companyList.vue?vue&type=style&index=0&id=1902bcf4&scoped=true&lang=css&"
import style1 from "./companyList.vue?vue&type=style&index=1&id=1902bcf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902bcf4",
  null
  
)

export default component.exports